export default function Services() {
  const services = [
    {
      icon: 'ri-sofa-line',
      title: 'Furniture Removal',
      description: 'Sofas, beds, tables, chairs, and all types of furniture removed safely and efficiently from any location in your home or business.',
      image: 'https://public.readdy.ai/ai/img_res/c3a06db555456df16a581310bcd19ac1.jpg'
    },
    {
      icon: 'ri-fridge-line',
      title: 'Appliance Disposal',
      description: 'Refrigerators, washers, dryers, stoves, and other appliances properly recycled according to environmental regulations and safety standards.',
      image: 'https://readdy.ai/api/search-image?query=Old%20refrigerator%20and%20washing%20machine%20ready%20for%20eco-friendly%20disposal%20and%20recycling%2C%20clean%20garage%20setting%2C%20bright%20lighting%2C%20professional%20removal%20service%2C%20realistic%20photography%20style&width=600&height=400&seq=service-002&orientation=landscape'
    },
    {
      icon: 'ri-home-4-line',
      title: 'Estate Cleanouts',
      description: 'Complete property cleanouts for estates, foreclosures, and downsizing with respectful handling of belongings and efficient removal services.',
      image: 'https://readdy.ai/api/search-image?query=Empty%20clean%20room%20after%20complete%20estate%20cleanout%20service%2C%20bright%20spacious%20interior%2C%20natural%20window%20light%2C%20professional%20cleaning%20result%2C%20high%20quality%20photography&width=600&height=400&seq=service-003&orientation=landscape'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Construction Debris',
      description: 'Removal of construction waste, renovation debris, drywall, lumber, and building materials from residential and commercial construction sites.',
      image: 'https://readdy.ai/api/search-image?query=Construction%20debris%20and%20building%20materials%20neatly%20organized%20for%20removal%2C%20clean%20construction%20site%2C%20bright%20daylight%2C%20professional%20waste%20management%2C%20realistic%20photography%20style&width=600&height=400&seq=service-004&orientation=landscape'
    },
    {
      icon: 'ri-plant-line',
      title: 'Yard Waste Removal',
      description: 'Branches, leaves, grass clippings, and landscaping debris removed and properly composted or recycled for environmental sustainability.',
      image: 'https://readdy.ai/api/search-image?query=Pile%20of%20yard%20waste%20including%20branches%20leaves%20and%20grass%20clippings%20in%20beautiful%20garden%20setting%2C%20natural%20outdoor%20lighting%2C%20eco-friendly%20disposal%2C%20high%20quality%20photography&width=600&height=400&seq=service-005&orientation=landscape'
    },
    {
      icon: 'ri-delete-bin-line',
      title: 'General Junk Hauling',
      description: 'Any unwanted items, clutter, or miscellaneous junk removed from homes, offices, garages, basements, and storage units quickly and affordably.',
      image: 'https://readdy.ai/api/search-image?query=Various%20household%20junk%20and%20clutter%20items%20organized%20for%20removal%2C%20clean%20organized%20space%2C%20bright%20natural%20lighting%2C%20professional%20hauling%20service%2C%20realistic%20photography%20style&width=600&height=400&seq=service-006&orientation=landscape'
    },
    {
      icon: 'ri-truck-line',
      title: 'Moving & Packing',
      description: 'Full-service moving and packing solutions for residential and commercial relocations across New Jersey. We carefully pack, load, transport, and unload your belongings with the same care and professionalism you expect from Garden State Junk Removal.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20carefully%20packing%20cardboard%20boxes%20and%20loading%20furniture%20into%20a%20moving%20truck%2C%20clean%20bright%20suburban%20home%20setting%2C%20organized%20moving%20supplies%2C%20bubble%20wrap%20and%20tape%2C%20natural%20daylight%2C%20professional%20moving%20service%2C%20high%20quality%20realistic%20photography&width=600&height=400&seq=service-007-moving&orientation=landscape'
    }
  ];

  const restrictedItems = [
    { text: 'animal or', highlight: true },
    { text: 'human waste,', highlight: true },
    { text: 'asbestos,', highlight: true },
    { text: 'chemicals,', highlight: true },
    { text: 'dirt,', highlight: true },
    { text: 'brush, or', highlight: true },
    { text: 'organic yard waste,', highlight: true },
    { text: 'explosives,', highlight: true },
    { text: 'fertilizers,', highlight: true },
    { text: 'fire extinguishers,', highlight: true },
    { text: 'flammable items,', highlight: true },
    { text: 'fluorescent lighting,', highlight: true },
    { text: 'food waste* (large quantities),', highlight: true },
    { text: 'hazardous materials,', highlight: true },
    { text: 'lithium batteries,', highlight: true },
    { text: 'paint,', highlight: true },
    { text: 'pressurized canisters (empty or full), or', highlight: true },
    { text: 'unknown liquids or materials', highlight: true }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-teal-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-service-line text-teal-600 text-lg"></i>
            <span className="text-teal-700 text-sm font-semibold">Our Services</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Junk Removal Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From furniture removal to complete estate cleanouts, we handle all your junk removal needs with professionalism and care. Transparent pricing with no hidden fees.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <button
              onClick={() => {
                const bookingSection = document.getElementById('booking');
                if (bookingSection) {
                  bookingSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              Request Free Estimate
            </button>
            <a
              href="tel:+19089021076"
              className="bg-gray-900 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-800 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap flex items-center space-x-2 cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>Call (908) 902-1076</span>
            </a>
          </div>
        </div>

        {/* Feature Badges */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16 max-w-4xl mx-auto">
          <div className="bg-teal-50 border border-teal-200 p-6 rounded-2xl text-center hover:shadow-lg transition-shadow duration-300">
            <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-3">
              <i className="ri-time-line text-white text-2xl"></i>
            </div>
            <h3 className="text-gray-900 font-bold text-lg mb-2">Same-Day Service</h3>
            <p className="text-gray-600 text-sm">Quick response and flexible scheduling for your convenience</p>
          </div>
          <div className="bg-teal-50 border border-teal-200 p-6 rounded-2xl text-center hover:shadow-lg transition-shadow duration-300">
            <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-3">
              <i className="ri-leaf-line text-white text-2xl"></i>
            </div>
            <h3 className="text-gray-900 font-bold text-lg mb-2">Eco-Friendly</h3>
            <p className="text-gray-600 text-sm">We recycle and donate whenever possible to protect our environment</p>
          </div>
          <div className="bg-teal-50 border border-teal-200 p-6 rounded-2xl text-center hover:shadow-lg transition-shadow duration-300">
            <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-3">
              <i className="ri-shield-check-line text-white text-2xl"></i>
            </div>
            <h3 className="text-gray-900 font-bold text-lg mb-2">Fully Insured</h3>
            <p className="text-gray-600 text-sm">Licensed and insured for your peace of mind and protection</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 group"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-teal-600 text-3xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {service.description}
                </p>
                <button className="text-teal-600 font-semibold text-sm hover:text-teal-700 transition-colors flex items-center space-x-2 group whitespace-nowrap">
                  <span>Learn More</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* We Do Not Take Section */}
        <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 shadow-lg border-2 border-red-100">
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center">
            We Do Not Take
          </h3>
          <div className="text-center text-base md:text-lg leading-relaxed max-w-5xl mx-auto">
            <p className="text-gray-700">
              We cannot remove <span className="text-red-600 font-bold">X</span> animal or <span className="text-red-600 font-bold">X</span> human waste,{' '}
              <span className="text-red-600 font-bold">X</span> asbestos, <span className="text-red-600 font-bold">X</span> chemicals,{' '}
              <span className="text-red-600 font-bold">X</span> dirt, <span className="text-red-600 font-bold">X</span> brush, or{' '}
              <span className="text-red-600 font-bold">X</span> organic yard waste, <span className="text-red-600 font-bold">X</span> explosives,{' '}
              <span className="text-red-600 font-bold">X</span> fertilizers, <span className="text-red-600 font-bold">X</span> fire extinguishers,{' '}
              <span className="text-red-600 font-bold">X</span> flammable items, <span className="text-red-600 font-bold">X</span> fluorescent lighting,{' '}
              <span className="text-red-600 font-bold">X</span> food waste* (large quantities), <span className="text-red-600 font-bold">X</span> hazardous materials,{' '}
              <span className="text-red-600 font-bold">X</span> lithium batteries, <span className="text-red-600 font-bold">X</span> paint,{' '}
              <span className="text-red-600 font-bold">X</span> pressurized canisters (empty or full), or{' '}
              <span className="text-red-600 font-bold">X</span> unknown liquids or materials
            </p>
          </div>
        </div>

        {/* Hours of Operation */}
        <div className="mt-12 bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-8 md:p-10 text-center shadow-xl">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <i className="ri-time-line text-white text-3xl"></i>
            <h3 className="text-2xl md:text-3xl font-bold text-white">
              Hours of Operation
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto mt-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5">
              <div className="text-teal-100 text-sm font-semibold mb-2">Monday - Friday</div>
              <div className="text-white text-2xl font-bold">7:00 AM - 7:00 PM</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5">
              <div className="text-teal-100 text-sm font-semibold mb-2">Saturday</div>
              <div className="text-white text-2xl font-bold">7:00 AM - 5:00 PM</div>
            </div>
          </div>
          <p className="text-teal-100 text-sm mt-6">Closed Sundays</p>
        </div>

        <div className="mt-16 bg-teal-600 rounded-2xl p-8 md:p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Why Choose Garden State Junk Removal?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mt-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">25+</div>
              <div className="text-teal-100 text-sm">Years of Experience</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">10,000+</div>
              <div className="text-teal-100 text-sm">Jobs Completed</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">95%</div>
              <div className="text-teal-100 text-sm">Recycled or Donated</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">100%</div>
              <div className="text-teal-100 text-sm">Customer Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}